export default class Item {
  constructor(item = {}) {
    this.id = item.id;
    this.name = item.name;
    this.description = item.description;
    this.order = item.order;
    this.thumbnail = item.thumbnail;
    this.publicVisible = item.public_visible;
    this.isDemo = item.is_demo;
    this.videoThumbnail = item.video_thumbnail;
    // this.subtitlesFile = item.subtitles_file;
    this.subtitlesFileNl = item.subtitles_file_nl;
    this.subtitlesFileEn = item.subtitles_file_en;
    this.is_motor = item.is_motor || false;
    this.is_auto = item.is_auto || false;
    this.is_scooter = item.is_scooter || false;
    this.is_wiki = item.is_wiki || false;
    this.is_les = item.is_les || false;
    this.is_online = item.is_online || false;

    this._apiAttributes = {
      name: 'name',
      order: 'order',
    }
  }

  get licenseTypes() {
    const licenseTypes = [];
    if (this.is_motor) licenseTypes.push('motor');
    if (this.is_auto) licenseTypes.push('auto');
    if (this.is_scooter) licenseTypes.push('scooter');
    return licenseTypes.join(', ');
  }

  validate (validator) {
    validator.resetFields()
    this.validateLicenseTypes(validator)
    return validator.isValid()
  }

  validateLicenseTypes(validator) {
    if (!this.is_motor && !this.is_auto && !this.is_scooter) {
      validator.invalidField('licenseTypes', 'At least one license type should be selected');
    }
  }

  getApiData() {
    const apiData = {
      name: this.name,
      order: this.order,
      description: this.description,
      public_visible: this.publicVisible,
      is_demo: this.isDemo,
      thumbnail: this.thumbnail,
      video_thumbnail: this.videoThumbnail,
      is_motor: this.is_motor || false,
      is_auto: this.is_auto || false,
      is_scooter: this.is_scooter || false,
      is_wiki: this.is_wiki || false,
      is_les: this.is_les || false,
      is_online: this.is_online || false,
    };
    if (this.subtitlesFileNl) {
      apiData.subtitles_file_nl = this.subtitlesFileNL;
    }
    if (this.subtitlesFileEn) {
      apiData.subtitles_file_en = this.subtitlesFileEn;
    }
    return apiData;
  }
}
